import { Typography } from 'components/generic/typography';
import { Price, Products } from 'autogen/translation-keys/trans-website-basket';
import { ColorNordicGrey1, Spacing16 } from 'autogen/design-tokens/tokens';
import Flex from 'components/Layout/components/Flex';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { BasketLineGroupViewModel } from 'autogen/swagger/all';
import BasketGroupRenderer from './BasketGroupRenderer';

const StyledFlexRow = styled(Flex.Row)`
    border-bottom: 1px solid ${ColorNordicGrey1};
    padding-bottom: ${Spacing16};
`;

export default function BasketItems({ model: basketGroups }: { model: BasketLineGroupViewModel[] }) {
    const { t } = useTranslation();

    if (!basketGroups.length) return null;

    return (
        <Flex.Column>
            <StyledFlexRow justifyContent="space-between">
                <Typography.Title size="S">{t(Products)}</Typography.Title>

                <Typography.Title size="S">{t(Price)}</Typography.Title>
            </StyledFlexRow>

            <BasketGroupRenderer model={basketGroups} />
        </Flex.Column>
    );
}
